import { Component, OnInit } from '@angular/core';
import { Header, IStrapiDocuments } from 'src/app/interfaces/strapi';
import { AuthService } from 'src/app/services/auth.service';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-eis-header',
    templateUrl: './eis-header.component.html',
    styleUrls: ['./eis-header.component.scss'],
    imports: [NgIf],
})
export class EisHeaderComponent implements OnInit {
  public headerData: Header | undefined;

  constructor(
    public readonly auth: AuthService,
    private readonly strapi: StrapiService
  ) {}

  /**
   * Get dashboard, header and current user
   */
  ngOnInit(): void {
    this.strapi.getHeaders().subscribe((data: IStrapiDocuments<Header>) => {
      this.headerData = this.parseHeaderData(data.data[0].attributes);
    });
  }

  private parseHeaderData(page: Header): Header {
    const parsed = <Header>{};
    const theData = page;

    if (theData.logo) parsed.logo = theData.logo;

    return parsed;
  }
}
